import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Habit, HabitColor, useHabits } from "@/context/SupabaseHabitContext";
import ColorPicker from "./ColorPicker";
import { toast } from "sonner";
import { Check } from "lucide-react";

interface EditHabitFormProps {
  habit: Habit;
  onClose: () => void;
  onUpgradeRequired?: () => void;
}

export default function EditHabitForm({ habit, onClose, onUpgradeRequired }: EditHabitFormProps) {
  const [name, setName] = useState(habit.name);
  const [selectedColor, setSelectedColor] = useState<HabitColor>(habit.color);
  const { updateHabit } = useHabits();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!name.trim()) {
      toast.error("Please enter a habit name");
      return;
    }
    
    updateHabit(habit.id, {
      name: name.trim(),
      color: selectedColor
    });
    toast.success(`Habit "${name}" updated`);
    
    onClose();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <Input
          type="text"
          placeholder="Habit name..."
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full"
          maxLength={50}
        />
      </div>
      
      <div>
        <p className="text-sm font-medium mb-1">Choose a color (colour code to help stack your habits)</p>
        <ColorPicker 
          selectedColor={selectedColor} 
          onSelectColor={setSelectedColor} 
          onUpgradeRequired={onUpgradeRequired}
        />
      </div>
      
      <Button type="submit" className="w-full mt-4">
        <Check size={16} className="mr-1" /> Save Changes
      </Button>
    </form>
  );
}
